<template>
  <form
    @submit.prevent="handleSearch"
    ref="form"
    class="clearfix _mb-10">

    <div class="col-sm-11">
      <div class="form-group-inline">
        <label class="sr-only" for="companySearch">
          Pesquise por nome fantasia, razão social ou cnpj
        </label>
        <input
          v-model="inputSearch"
          v-validate="'required'"
          :class="{ 'alert-danger': errors.has('search') }"
          id="companySearch"
          type="search"
          name="search"
          class="form-control"
          placeholder="*Pesquise por nome fantasia, razão social ou cnpj" />
        <span
          v-if="errors.has('search')"
          class="theme-form-error-message">*{{ errors.first('search') }}</span>
      </div>
    </div>

    <div class="col-sm-1 padding-off">
      <div class="form-group">
        <button
          v-if="!search"
          :disabled="submitted"
          type="submit"
          class="btn-green btn-block btn-extra-large"
          value="Buscar Empresa">
          <i aria-hidden="true" class="fa fa-search"></i>
        </button>

        <button
          v-if="search"
          @click="handleReset"
          :disabled="submitted"
          type="reset"
          class="btn-green-inverse btn-block btn-extra-large"
          value="Limpar">
          <i aria-hidden="true" class="fa fa-close"></i>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: [
    'page',
    'ordering',
    'search',
    'submitted'
  ],
  data () {
    return {
      inputSearch: null
    }
  },
  methods: {
    handleSearch () {
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.$emit('handleCompanies', {
              page: this.page,
              ordering: this.ordering,
              search: this.inputSearch
            })
          }
        })
    },
    handleReset () {
      this.$refs.form.reset()
      this.$validator.reset()
      this.inputSearch = null
      this.$emit('handleCompanies', {
        page: 1,
        ordering: 'name',
        search: null
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/components/forms/ScopedForms';
</style>
